import React from "react"
import {FieldEditableProps} from "../../../../proto/render/editable";
import FieldPopover_EditableProto from "../../../popover/render/editable/editable-proto";
import ItemModel from "../../../../../model2/item/item-model";
import FieldProto from "../../../../proto/field-proto";

// const debug = "FieldItemModelStoryPointsCalculated_TableCell"
const debug = false

type State = {
    isHovered   : boolean
    showPopover : boolean
}

export default function FieldProgress_Editable(props:FieldEditableProps) {

    const renderValue = (field:FieldProto, model:ItemModel) => {

        const value = field.getViewValue(model)

        if (_.isNil(value)) return false;

        const excess            = value > 100;
        const currentValue      = excess ? Math.floor(100 * (100 / value)) : value;
        const progressClasses   = Classes("ui5-progress", "in-ui5-field", {
            'excess-v2':    excess,
        });

        const classes           = Classes("ui5-txt-less-important-small", "w-100-percent", "", "txt-truncate")

        const displayProgressBar = true // style.width > 120

        if (!displayProgressBar) {
            return (
                <div className={classes}>
                    <div className={progressClasses}>
                        {!_.isNil(currentValue) &&
                            <div className="ui5-txt-less-important-small percentage txt-truncate">
                                {"{0}%".f(currentValue)}
                            </div>
                        }
                    </div>
                </div>
            );
        }

        return (
            <div className={progressClasses}>
                <div className="progress-bg max-w-150">
                    {!!currentValue && <div className="progress-line" style={{width: '{0}%'.f(currentValue)}}/>}
                </div>
                {!_.isNil(currentValue) &&
                    <div className="m-l-10 ui5-txt-less-important-small">
                        {"{0}%".f(currentValue)}
                    </div>
                }
            </div>
        )

        // return (
        //     <div className={classes}>
        //
        //     </div>
        // );



    }


    return <FieldPopover_EditableProto {...props}
                                       renderValueHovered={renderValue}
                                       renderValue={renderValue} />

    //
    // constructor(props:FieldEditableProps) {
    //     super(props)
    //
    //     this.state = {
    //         isHovered   : false,
    //         showPopover : false
    //     }
    // }
    //
    // onMouseEnter = () => {
    //
    //     if (!this.props.field.canEdit(this.props.model)) return
    //
    //     if (!this.state.isHovered) this.setState({
    //         isHovered   : true
    //     })
    // }
    //
    // onMouseLeave = () => {
    //     if (this.state.showPopover) return //
    //
    //     if (this.state.isHovered) this.setState({
    //         isHovered   : false
    //     })
    // }
    //
    // get classes():string {
    //     const classes = Classes("ui5-field-editable", this.props.className, {
    //         "ui5-txt-default"               : this.props.size === FieldViewSize.DEFAULT,
    //         "size-default"                  : this.props.size === FieldViewSize.DEFAULT,
    //         "ui5-txt-less-important-small"  : this.props.size === FieldViewSize.SMALL,
    //         "size-small"                    : this.props.size === FieldViewSize.SMALL,
    //     })
    //     return classes
    // }
    //
    // onValueChange(value:Priority, hidePopover:boolean=true) {
    //
    //     // we do not need to update childrend items etc... just save the current item and rerender cell
    //
    //     // @ts-ignore
    //     this.props.model.priority = value
    //     this.props.model.save() // no await !
    //
    //     // // need it because of calculated values
    //     // this.props.manager.updateChildrenItems();
    //
    //     hidePopover && this.hidePopover()
    //
    //     this.props.onChange && this.props.onChange(value)
    // }
    //
    // onClick = () => {
    //     if (!this.props.field.canEdit(this.props.model)) return
    //     // if (!this.isEditable) return
    //
    //     this.setState({
    //         showPopover     : !this.state.showPopover
    //     })
    //
    // }
    //
    // onOptionClick = (option:Option) => {
    //     this.onValueChange(option.value as Priority)
    // }
    //
    // hidePopover = () => {
    //     this.setState({
    //         showPopover     : false,
    //         isHovered       : false
    //     })
    // }
    //
    // renderHovered() {
    //
    //     const field     = this.props.field
    //     const classes   = Classes(this.classes, "is-hovered")
    //
    //     // ui5-field-editable is-hovered w-100-percent h-100-percent
    //
    //     return (
    //         <React.Fragment>
    //             <div className={classes} style={this.props.style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave} onClick={this.onClick}>
    //                 {this.renderValue(this.props.style?.width)}
    //
    //                 {!this.props.iconOnly &&
    //                     <div className="buttons flex-no-shrink">
    //                         <div className="btn-arrow"/>
    //                     </div>
    //                 }
    //
    //                 {this.state.showPopover &&
    //                     <field.components.PopoverMenu {...this.props} parent={this} />
    //                 }
    //
    //             </div>
    //         </React.Fragment>
    //     )
    // }
    //
    // renderValue(width: number) {
    //
    //     // @ts-ignore
    //     const option : Option = this.props.field._getOption(this.props.model.priority)
    //
    //     if (this.props.iconOnly) {
    //         return (
    //             <div className={Classes("flex-row-center-center", "w-100-percent", "txt-truncate")}>
    //                 <PriorityIcon className="" priority={option.value}/>
    //             </div>
    //         )
    //     }
    //
    //
    //     return (
    //         <div className={Classes("flex-row-left-center", "w-100-percent", "txt-truncate")}>
    //             <PriorityIcon className="fl-no-shrink m-r-5" priority={option.value}/>
    //             <div className="max-w-100-percent txt-truncate cursor-default">{option.label}</div>
    //         </div>
    //     )
    // }
    //
    // renderNotHovered() {
    //
    //     return (
    //         <React.Fragment>
    //             <div className={this.classes} style={this.props.style} onMouseEnter={this.onMouseEnter} onMouseLeave={this.onMouseLeave}>
    //
    //                 {this.renderValue(this.props.style?.width)}
    //
    //             </div>
    //         </React.Fragment>
    //     )
    //
    // }
    //
    // render() {
    //     // debug && console.log(debug, "render()", this.props)
    //     debug && console.log(debug, "render() isHovered=", this.state.isHovered)
    //
    //
    //     if (this.state.isHovered) return this.renderHovered()
    //     else return this.renderNotHovered()
    //
    // }

}



